import { Component, HostListener, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AdminAnalyticsService } from 'app/core/analytics/admin-analytics.service';
import { ProductAnalyticsTrackingService } from 'app/services/product-analytics-tracking.service';
import { ScreenService } from './services/screen-size.service';
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [RouterOutlet]
})
export class AppComponent implements OnInit {
    constructor(
        private screenService: ScreenService,
        private _productAnalytics: ProductAnalyticsTrackingService,
        private _adminAnalytics: AdminAnalyticsService
    ) { }


    @HostListener('window:resize', [])
    onResize(): void {
        this.screenService.updateScreenSize();
    }

    ngOnInit(): void {
        this.screenService.updateScreenSize();
        // Two independent pipelines: first-party (our DB, per-click detail)
        // and GA4 (admin stream, page views + sign-in/out only).
        this._productAnalytics.start();
        this._adminAnalytics.start();
    }
}
